import { render, staticRenderFns } from "./CourseLoader.vue?vue&type=template&id=103adfe5&"
import script from "./CourseLoader.vue?vue&type=script&lang=js&"
export * from "./CourseLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports